import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_292240a2 from 'nuxt_plugin_plugin_292240a2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_libplugin1ac4a4dc_0fda082e from 'nuxt_plugin_libplugin1ac4a4dc_0fda082e' // Source: ./lib.plugin.1ac4a4dc.js (mode: 'all')
import nuxt_plugin_nuxtmq_2539fc80 from 'nuxt_plugin_nuxtmq_2539fc80' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_googlegtag_819ad932 from 'nuxt_plugin_googlegtag_819ad932' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_axios_4a36ceb8 from 'nuxt_plugin_axios_4a36ceb8' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_198e75d4 from 'nuxt_plugin_workbox_198e75d4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_7c4ea8e7 from 'nuxt_plugin_metaplugin_7c4ea8e7' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_fe13634a from 'nuxt_plugin_iconplugin_fe13634a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_vuescrollactive_8042ff6e from 'nuxt_plugin_vuescrollactive_8042ff6e' // Source: ../../../plugins/vue-scrollactive.js (mode: 'all')
import nuxt_plugin_vueheighttweentransition_35e662d6 from 'nuxt_plugin_vueheighttweentransition_35e662d6' // Source: ../../../plugins/vue-height-tween-transition.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfillclient_18f11b0b from 'nuxt_plugin_smoothscrollpolyfillclient_18f11b0b' // Source: ../../../plugins/smoothscroll-polyfill.client.js (mode: 'client')
import nuxt_plugin_vmaskclient_9235dc16 from 'nuxt_plugin_vmaskclient_9235dc16' // Source: ../../../plugins/v-mask.client.js (mode: 'client')
import nuxt_plugin_portalvue_8244bc84 from 'nuxt_plugin_portalvue_8244bc84' // Source: ../../../plugins/portal-vue.js (mode: 'all')
import nuxt_plugin_vlazyimage_356cef6a from 'nuxt_plugin_vlazyimage_356cef6a' // Source: ../../../plugins/v-lazy-image.js (mode: 'all')
import nuxt_plugin_diffuserclient_2945a7bc from 'nuxt_plugin_diffuserclient_2945a7bc' // Source: ../../../plugins/diffuser.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"SD Freight","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"SD Freight is your partner in transportation management. We provide a wide range of shipping options that save your company money without sacrificing quality."},{"hid":"keywords","name":"keywords","content":""},{"hid":"msapplication-TileColor","name":"msapplication-TileColor","content":"#da532c"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"},{"hid":"twitter:title","name":"twitter:title","content":"SD Freight"},{"hid":"og:title","name":"og:title","content":"SD Freight"},{"hid":"twitter:description","name":"twitter:description","content":"SD Freight is your partner in transportation management. We provide a wide range of shipping options that save your company money without sacrificing quality."},{"hid":"og:description","name":"og:description","content":"SD Freight is your partner in transportation management. We provide a wide range of shipping options that save your company money without sacrificing quality."},{"hid":"twitter:domain","name":"twitter:domain","content":"https:\u002F\u002Fsdfreightllc.com"},{"hid":"og:domain","name":"og:domain","content":"https:\u002F\u002Fsdfreightllc.com"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fsdfreightllc.com"},{"hid":"og:url","name":"og:url","content":"https:\u002F\u002Fsdfreightllc.com"},{"hid":"twitter:type","name":"twitter:type","content":"website"},{"hid":"og:type","name":"og:type","content":"website"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#5bbad5"}],"style":[],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-FG6JP751H9","async":true}]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_292240a2 === 'function') {
    await nuxt_plugin_plugin_292240a2(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin1ac4a4dc_0fda082e === 'function') {
    await nuxt_plugin_libplugin1ac4a4dc_0fda082e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_2539fc80 === 'function') {
    await nuxt_plugin_nuxtmq_2539fc80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_819ad932 === 'function') {
    await nuxt_plugin_googlegtag_819ad932(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4a36ceb8 === 'function') {
    await nuxt_plugin_axios_4a36ceb8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_198e75d4 === 'function') {
    await nuxt_plugin_workbox_198e75d4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_7c4ea8e7 === 'function') {
    await nuxt_plugin_metaplugin_7c4ea8e7(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_fe13634a === 'function') {
    await nuxt_plugin_iconplugin_fe13634a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescrollactive_8042ff6e === 'function') {
    await nuxt_plugin_vuescrollactive_8042ff6e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueheighttweentransition_35e662d6 === 'function') {
    await nuxt_plugin_vueheighttweentransition_35e662d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscrollpolyfillclient_18f11b0b === 'function') {
    await nuxt_plugin_smoothscrollpolyfillclient_18f11b0b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmaskclient_9235dc16 === 'function') {
    await nuxt_plugin_vmaskclient_9235dc16(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_8244bc84 === 'function') {
    await nuxt_plugin_portalvue_8244bc84(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyimage_356cef6a === 'function') {
    await nuxt_plugin_vlazyimage_356cef6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_diffuserclient_2945a7bc === 'function') {
    await nuxt_plugin_diffuserclient_2945a7bc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
